import { GET_SERVICE_REQUEST, ServiceRequest, ServiceResponse } from '@project/shared-types';
import apiFetchPost from '../apiClient';


export const ServiceHMAPI = async (dataRequest: ServiceRequest) => {
    const response = await apiFetchPost<ServiceRequest, ServiceResponse>(
        GET_SERVICE_REQUEST,
        dataRequest
    );
    return response;
};
